module.exports = __webpack_public_path__ + "media/images/new_home/8-chef-jj-660e75bbac1427bbd8ec013950a6c805.png";